"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledSnackWhen = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _colors = _interopRequireDefault(require("@fe/ui/colors"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SnackWhen extends _react.default.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      show: true
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.test && nextProps.test !== this.props.test) {
      this.setState({
        show: true
      });
    }
  }
  render() {
    const _this$props = this.props,
      type = _this$props.type,
      classes = _this$props.classes;
    return /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
      onClose: (e, reason) => this.setState({
        show: !(type === 'confirmation' || reason === 'clickaway')
      }),
      autoHideDuration: type === 'confirmation' ? 5000 : null,
      open: this.props.test && this.state.show,
      anchorOrigin: {
        vertical: this.props.top ? 'top' : 'bottom',
        horizontal: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_SnackbarContent.default, {
      className: type === 'error' ? classes.error : type === 'warning' ? classes.warning : type === 'confirmation' ? classes.confirmation : classes.default,
      message: this.props.children
    }));
  }
}
_defineProperty(SnackWhen, "propTypes", {
  test: _propTypes.default.bool.isRequired,
  selector: _propTypes.default.func.isRequired,
  children: _propTypes.default.string.isRequired,
  top: _propTypes.default.bool,
  type: _propTypes.default.string
});
_defineProperty(SnackWhen, "defaultProps", {
  top: false,
  type: 'loading'
});
const StyledSnackWhen = exports.StyledSnackWhen = (0, _withStyles.default)(theme => ({
  close: {
    width: theme.spacing(1) * 4,
    height: theme.spacing(1) * 4
  },
  default: {
    backgroundColor: _colors.default.businessBlue,
    color: _colors.default.white
  },
  confirmation: {
    backgroundColor: _colors.default.pieLightBlue,
    color: _colors.default.white
  },
  error: {
    backgroundColor: _colors.default.primaryRed,
    color: _colors.default.white
  },
  warning: {
    backgroundColor: _colors.default.primaryOrange,
    color: _colors.default.white
  }
}))(SnackWhen);
var _default = exports.default = (0, _reactRedux.connect)((s, _ref) => {
  let selector = _ref.selector;
  return {
    test: Boolean(selector(s))
  };
})(StyledSnackWhen);